
<template>

    <div id="virtualEditor">

        <div class="visual-editor">

            <div id="dom-node">

                <div class="img-content">
                    
                    <img class="img-content-local" :src="imgEditor64" />

                    <div class='editor-draggable'>

                        <div class="editor-drag-dialog">
                            {{tryonTraducciones.tryon_bocadillo1}}
                        </div>

                        <img :src="producto.url_imagen">
                        <div class="circle-btn handle-rotate"><img :src="baseURL+'/modules/supercheckout/images/rotar.png'" ></div>
                        <div class='handle-scale'>

                            <img :src="baseURL+'/modules/supercheckout/images/tamano.png'" >

                        </div>
                    </div>
                    
                </div>

            </div>

            <div class="circle-btn right btn-fin" @click="captureImg" ><img :src="baseURL+'/modules/supercheckout/images/fin.png'" ></div>

         </div>

    </div>

</template>


<script>

import domtoimage from 'dom-to-image';
import html2canvas from 'html2canvas';

export default {

    props: ['imgEditor64', 'producto'],

    data(){
        return {
            title: 'categorias',
            baseURL,
            tryonTraducciones,
            urlBakcCamera: null
        }
    },

    mounted: function () {

        // Logica de fotografia para compartir
        //---------------------------------------------------

        let startX, startY;
        let xActual = null;
        let multiplicador = 1;
        let xAument = 0;

        const editorImage = $('.img-content')
        const drag = $('.editor-draggable');
        const dragImg = drag.find('img')
        const handleScale = drag.find('.handle-scale')
        const handleRotate = drag.find('.handle-rotate')

        // Lo hacemos drageable limitando su bounds
        Draggable.create(drag, { 
            bounds: editorImage,
            onPress: function(){
                 $('.editor-drag-dialog').hide()
            }
        });

        // Funcion de SCALE
        Draggable.create(handleScale, {
            type:"top,left",
            onPress: function(e) {
                e.stopPropagation();
                
                startX = this.x;
                startY = this.y;
            },
            onDrag: function(e) {

                if(!xActual) xActual = drag[0].getBoundingClientRect().width;

                var xMouse = this.x - startX
                var yMouse = this.y - startY

                if(drag[0].getBoundingClientRect().width <= 150){

                    if(xMouse > 0){
                        xAument = xActual + (xMouse * multiplicador)
                        var xRate = ( xAument * 1 ) / drag.width()
                        TweenMax.set(drag, {scale:xRate});
                    }

                    return;

                }
            
                xAument = xActual + (xMouse * multiplicador)
                var xRate = ( xAument * 1 ) / drag.width()
                TweenMax.set(drag, {scale:xRate});

            },
            onDragEnd: function(e) {
                xActual = xAument;
                multiplicador = (xActual * 4 / 600)
            },
        });

        // Funcion de Rotación
        Draggable.create(handleRotate, {
            type:"scroll",
            lockAxis:true,
            onPress: function(e) { Draggable.create(drag, { type: "rotation", throwProps: true }); },
            onRelease: function(e){ Draggable.create(drag,{ bounds: editorImage }); }
        });
        

        TweenLite.set(drag, {transform: this.producto.transform });




        // const _this = this

        // let fdata = new FormData();

        // fdata.append("capture64", this.imgEditor64);

        // $.ajax({
        //     type: 'POST',
        //     url: `${linkModulo}?save_image=1`,
        //     data: fdata,
        //     contentType: false,
        //     processData: false,
        //     success: function(response){

        //         let responseJson = JSON.parse(response)

        //         _this.urlBakcCamera = `https://yourwayco.com/img/tryon/imgs/${responseJson.name}.png`

        //         console.log( _this.urlBakcCamera )

        //     }
        // })

     
    },

    methods: {
        
        captureImg: function(){

            $('.editor-drag-dialog').hide()

            const _this = this

            $('.img-content').css('width', $('.img-content-local').width()  )
            $('.img-content').css('height', $('.img-content-local').height()  )


            let scale = 2
            let element = document.getElementById('dom-node')

            $('#dom-node').css({
                width: $('.img-content-local').width(),
                height: $('.img-content-local').height()
            })

            // domtoimage.toPng(element, {
            //     width: element.offsetWidth * scale,
            //     height: element.offsetHeight * scale,
            //     style: {
            //     'transform': `scale(${scale})`,
            //     'transform-origin': 'top left'
            //     }
            // }).then(function(dataUrl) {
            //      _this.$emit('on-capture', dataUrl )
            // })

            html2canvas(element).then(canvas => {

                _this.$emit('on-capture', canvas.toDataURL() )

            });

        }

    }

}

</script>



<style lang="scss">


    #virtualEditor{
        text-align: center;
        display: flex;
        overflow: hidden;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        max-width: 1200px;
        position: relative;



        .visual-editor{
            position: relative;
            // line-height: 0;
            margin: 20px 0;
            box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        }

        .img-content {
            overflow: hidden;
            height: 500px;

            .img-content-local{
                height: 100%;
                pointer-events: none;
                user-select: none;
            }

        }

        .editor-drag-dialog {
            padding: 10px 20px;
            z-index: 3;
            top: -100px;
            position: absolute;
            color: #fff;
            background: #333;
            height: 70px;
            border-radius: 12px;
            text-align: -webkit-left;
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 200px;

            &:before{
                content: "";
                position: absolute;
                width: 30px;
                height: 30px;
                background: #333333;
                transform: rotate(45deg);
                left: 29px;
                bottom: -13px;
                z-index: 2;
            }

        }

        .editor-draggable {
            position: absolute;
            width: 220px;
            height: 100px;
            border: 2px solid #fff;
            top: 100px;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            z-index: 3;
           
        }
        
        .editor-draggable img {
            width: 100%;
            position: absolute;
            user-select: none;
            pointer-events: none;
            -webkit-touch-callout: none; // for iOS




        }
        
        .handle-scale {
            border-style: solid;
            border-color: transparent transparent #ed3a5b;
            cursor: nw-resize!important;
            display: flex;
            justify-content: center;
            align-items: center;
            border-width: 0 0 47px 47px;
            width: 47px;
            height: 47px;

            img{
                position: relative!important;
                width: 20px;
                top: 35px;
                left: -12px;
            }

        }
    
        .handle-rotate {
            top: -40px;
            right: -40px;
            z-index: 10;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 60px !important;
            height: 60px !important;
            padding: 0;
            margin: 0;

            div {
                display: inherit;
                position: inherit;
                overflow: inherit;
                vertical-align: inherit;
                width: inherit;
                padding-right: inherit;
                padding-bottom: inherit;
            }

            img{
                position: relative;
                width: 70% !important;
            }

        }
    
        .editor-draggable:not(:hover):not(:active){
            border: none;
        }
        
        .editor-draggable:not(:hover):not(:active) .handle-scale{
            display: none;
        }
        
        .editor-draggable:not(:hover):not(:active) .handle-rotate{
            display: none;
        }

        .btn-fin{

            @media (max-width: 768px) { 
                left: calc(50% - 40px);
            }

        }



        .circle-btn{
            position: absolute;
            z-index: 10;
            bottom: 0;
            margin: 10px;

            width: 75px;
            height: 75px;

            img{
                width: 90%;
            }

        }

        .circle-btn.right{
            right: 0;
        }

    }



</style>



// WEBPACK FOOTER //
// src/components/VirtualEditor.vue